import { MAP_VIEW } from 'src/constant/map';

export const KPI_MAP = {
  nrg: {
    title: 'NRG',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  ms: {
    title: 'MS',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  scs: {
    title: 'SCS',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  le: {
    title: 'LE',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  dsc: {
    title: 'DSC',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  pc: {
    title: 'PC',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  gp: {
    title: 'GP',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}$${value}`,
  },
  dso: {
    title: 'DSO',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}`,
  },
  ar90: {
    title: 'AR90',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  cr: {
    title: 'CR',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  oe: {
    title: 'OBX',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
  ce: {
    title: 'CE',
    deltaFormat: (value) => `${value > 0 ? '+' : ''}${value}%`,
  },
};

export const KPI_TARGET = {
  oe: '80%',
  ce: '$70',
};

export const KPI_COLORS = {
  SUCCESS_BG: '#5CB85C',
  ERROR_BG: '#D9534F',
  WARNING_BG: '#F0AD4E',
  NEUTRAL_BG: '#9E9E9E',
  SUCCESS_TEXT: '#339F76',
  ERROR_TEXT: '#D9534F',
  WARNING_TEXT: '#D87011',
  NEUTRAL_TEXT: '#6A6A70',
};

export const COUNTRIES = [
  {
    label: 'United States',
    value: 'US',
    image: 'https://signalassets.blob.core.windows.net/signal/assets/usflag.png',
  },
  {
    label: 'Canada',
    value: 'CA',
    image: 'https://signalassets.blob.core.windows.net/signal/assets/canadaflag.png',
  },
];

export const DEFAULT_FILTER = {
  country: COUNTRIES[0],
  mapView: MAP_VIEW.country,
  layersToggle: {
    lotsMarker: false,
    lotsBoundary: true,
    franchiseMarker: false,
  },
};

export const FILTERS_OPTIONS_MAP = {
  country: COUNTRIES,
};

export const findItemByValue = (name, value) => {
  return FILTERS_OPTIONS_MAP?.[name]?.find((item) => item.value == value) || {};
};

export const BREADCRUMB_TYPES = {
  KPI: 'kpi',
  LOT: 'lot',
  FRANCHISE: 'franchise',
  STATE: 'state',
  COUNTRY: 'country',
  HOME: 'home',
};
